(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('anbernic-menu-backdrop')) {
    customElements.define('anbernic-menu-backdrop', class extends HTMLElement {
      connectedCallback() {
        this.details = this.parentElement;
        this.drawer = this.details.querySelector(':scope > #menu-drawer');
        this.scheduleMeasure = () => {
          cancelAnimationFrame(this.measureFrame);
          this.measureFrame = requestAnimationFrame(() => this.measureMenu());
        };
        this.onclick = () => this.details.querySelector(':scope > summary')?.click();
        this.onpointerdown = event => event.preventDefault();
        this.menuObserver = new MutationObserver(this.scheduleMeasure);
        this.menuObserver.observe(this.details, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['open', 'class', 'hidden']
        });
        this.sizeObserver = new ResizeObserver(this.scheduleMeasure);
        this.drawer.querySelectorAll('.menu-drawer__menu, .menu-drawer__close-button, .menu-drawer__utility-links').forEach(element => {
          this.sizeObserver.observe(element);
        });
        window.addEventListener('resize', this.scheduleMeasure);
        window.visualViewport?.addEventListener('resize', this.scheduleMeasure);
        document.fonts?.ready.then(() => {
          if (this.isConnected) this.scheduleMeasure();
        });
        this.scheduleMeasure();
      }

      measureMenu() {
        if (!this.details.open || !window.matchMedia('(max-width: 989px)').matches) return;

        // Submenus are positioned panels; measure their natural list content,
        // so returning to a shorter menu also reduces the sheet height.
        const opened = this.drawer.querySelectorAll('details[open].menu-opening');
        const activeDetails = opened[opened.length - 1];
        const pane = activeDetails
          ? activeDetails.querySelector(':scope > .menu-drawer__submenu > .menu-drawer__inner-submenu')
          : this.drawer.querySelector('.menu-drawer__navigation');
        const list = pane?.querySelector(':scope > .menu-drawer__menu');
        if (!list) return;

        const paneStyle = getComputedStyle(pane);
        let contentHeight = list.scrollHeight + parseFloat(paneStyle.paddingTop) + parseFloat(paneStyle.paddingBottom);
        const backButton = pane.querySelector(':scope > .menu-drawer__close-button');
        if (backButton) {
          const buttonStyle = getComputedStyle(backButton);
          contentHeight += backButton.getBoundingClientRect().height + parseFloat(buttonStyle.marginTop) + parseFloat(buttonStyle.marginBottom);
        } else {
          contentHeight += this.drawer.querySelector('.menu-drawer__utility-links')?.getBoundingClientRect().height || 0;
        }
        this.details.style.setProperty('--am-menu-content-height', `${Math.ceil(contentHeight)}px`);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.measureFrame);
        this.menuObserver?.disconnect();
        this.sizeObserver?.disconnect();
        window.removeEventListener('resize', this.scheduleMeasure);
        window.visualViewport?.removeEventListener('resize', this.scheduleMeasure);
        this.onclick = null;
        this.onpointerdown = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-dropdown-menu"] && !Shopify.designMode) return;
  try {
    (() => {
    let measureFrame;
    const updateMenuHeight = () => {
      if (!window.matchMedia('(min-width: 990px)').matches) return;
      document.querySelectorAll('.header__inline-menu header-menu > details[open] > .list-menu--disclosure').forEach(menu => {
        // offsetTop excludes the popup's entrance animation transform.
        const parentTop = menu.offsetParent?.getBoundingClientRect().top || 0;
        menu.style.setProperty('--anbernic-desktop-menu-top', `${Math.max(0, Math.ceil(parentTop + menu.offsetTop))}px`);
      });
    };
    const scheduleMeasure = () => {
      cancelAnimationFrame(measureFrame);
      measureFrame = requestAnimationFrame(updateMenuHeight);
    };

    // Native details groups also close siblings without clicking their summary.
    document.addEventListener('toggle', event => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.closest('.header__inline-menu')) return;
      if (details.matches('details[name^="HeaderSubMenu-"]')) {
        details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(details.open));
      }
      scheduleMeasure();
    }, true);
    window.addEventListener('resize', scheduleMeasure);
    window.addEventListener('scroll', scheduleMeasure, { passive: true });
    document.addEventListener('transitionend', event => {
      if (event.target.matches?.('.section-header')) scheduleMeasure();
    }, true);
    document.fonts?.ready.then(scheduleMeasure);
  })();
  } catch(e) { console.error(e); }
})();

})();
